module.exports = __webpack_public_path__ + "static/media/logo.e9bfb390.svg";